import { IParameterizedValueConverter } from "aurelia-binding-ext";

// Add a prefix to a string in the view. Used for number formatting with a prefix, for example when adding a currency symbol
export class PrefixValueConverter implements IParameterizedValueConverter<string, string, string> {
    public toView(str: string, prefix = ""): string {
        return prefix + str;
    }

    public fromView(str: string, prefix = ""): string {
        return str.replace(RegExp("[^0-9,.]", "g"), "");
    }
}
